import type { Position } from 'components/map/types';

/** A waypoint without position is an empty row the user has not filled in yet */
export type Waypoint = { id: string; position?: Position };
export type PlacedWaypoint = Required<Waypoint>;

export const isPlaced = (waypoint: Waypoint): waypoint is PlacedWaypoint => waypoint.position !== undefined;
